


























































































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext
} from "@vue/composition-api";

import RealTimeTransferKey from "@/components/real-time-transfer-key";
import WalletKey from "@/components/wallet-key";
import MemberKey from "@/components/member-key";
import BankTransferKey from "@/components/bank-transfer-key";

export default createComponent({
  components: {},
  setup(props: {}, context: SetupContext) {
    const walletStore = inject(WalletKey);
    if (!walletStore) {
      throw new Error(`${WalletKey} is not provided`);
    }
    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }
    const realTimeTransferStore = inject(RealTimeTransferKey);
    if (!realTimeTransferStore) {
      throw new Error(`${RealTimeTransferKey} is not provided`);
    }
    const bankTransferStore = inject(BankTransferKey);
    if (!bankTransferStore) {
      throw new Error(`${BankTransferKey} is not provided`);
    }
    const globalStore = context.root.$store;
    const loadedFlag = ref<boolean>(false);
    const accessToken = computed(() => globalStore.auth.token);
    const companyWallet = computed(() => bankTransferStore.companyWallet);
    const selectBankTransferRequestInfos = computed(
      () => realTimeTransferStore.selectBankTransferRequestInfos
    );

    const walletList = computed(() => {
      let list = walletStore.walletList;
      let companyCodeList = bankTransferStore.companyCodeList;
      list.forEach((wallet: any, index: number) => {
        if (
          !companyCodeList.includes(wallet.company_code_item.internal_value)
        ) {
          list.splice(index, 1);
        }
      });
      return list;
    });

    const setSelectAccountInfos = (e: any) => {
      realTimeTransferStore.setSelectAccountInfos(e);
    };

    onMounted(async () => {
      loadedFlag.value = true;
      memberStore.setAuthorizationHeader(accessToken.value);
      walletStore.setAuthorizationHeader(accessToken.value);
      await memberStore.getMember();
      await walletStore.getWalletList();
      loadedFlag.value = false;
    });

    return {
      walletList,
      loadedFlag,
      companyWallet,
      selectBankTransferRequestInfos,
      setSelectAccountInfos
    };
  }
});
